import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/** POST /api/transportista/motivos/rechazo */
@Injectable({ providedIn: 'root' })
export class TransportistaMotivosRechazoGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/motivos/rechazo', {}, options);
  }
}
